import React from 'react'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faFacebookSquare,
  faWhatsappSquare,
  // faTwitterSquare,
  // faInstagramSquare,
} from '@fortawesome/free-brands-svg-icons'
// import amerex_logo from "../images/amerex-logo.svg"

const Footer = () => {
  return (
    <footer className='d-flex flex-column flex-md-row px-2 px-md-4 justify-content-around'>
      <div>
        <h5>PRODUCTOS</h5>
        <ul>
          <li>
            <Link to='/portatiles'>Extintores portátiles nacionales</Link>
          </li>
          <li>
            <Link to='/unidades-moviles'>Unidades móviles</Link>
          </li>
          <li>
            <Link to='/sistemas-incendio'>Sistemas contra incendio</Link>
          </li>
        </ul>
      </div>
      <div>
        <h5>LIGAS DE INTERÉS</h5>
        <ul>
          <li>
            <a
              href='https:///www.mecci.mx'
              target='_blank'
              rel='noopener noreferrer'
            >
              Website MECI
            </a>
          </li>
          <li>
            <a
              href='https://www.server.amerex.mx/pdf/product-catalog-spanish.pdf'
              target='_blank'
              rel='noopener noreferrer'
            >
              Descargar catálogo Amerex
            </a>
          </li>
          <li>
            <a
              href='https://www.server.amerex.mx/pdf/portatiles-catalog.pdf'
              target='_blank'
              rel='noopener noreferrer'
            >
              Descargar catálogo extintores portátiles
            </a>
          </li>
          <li>
            <a
              href='https://www.server.amerex.mx/pdf/um-catalog.pdf'
              target='_blank'
              rel='noopener noreferrer'
            >
              Descargar catálogo Unidades Móviles
            </a>
          </li>
          <li>
            <Link to='/aviso-privacidad'>Ver aviso de privacidad</Link>
          </li>
        </ul>
      </div>
      <div>
        <h5>CONTACTO</h5>
        <p>
          Sonora 768 Sur Monterrey, NL México <br />
          Conmutador: <a href='tel:8115349214'>(81) 1534-9214</a>
          <br />
          Ventas:{' '}
          <a href='mailto:ventas@amerex-mexico.com'>ventas@amerex-mexico.com</a>
          <br />
          Facturación:{' '}
          <a href='mailto:facturacion@amerex-mexico.com'>
            facturacion@amerex-mexico.com
          </a>
        </p>
<hr/>
{/* <p>
        Lic. Edith Guillen
        <br />
        Ventas a Gobierno y Licitaciones
        <br />
        +52 56-1174-2199
        <br />
        <a href="mailto:eguillen@mercantil.mx">eguillen@mercantil.mx</a>
      </p> */}
        <a
          href='https://www.facebook.com/amerexmexico'
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Visitar página de Amerex en Facebook'
        >
          <FontAwesomeIcon className='fa-3x mx-1' icon={faFacebookSquare} />
        </a>
        <a
          href='https://wa.me/message/M55IVMFYJGL4A1'
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Solicitar información por WhatsApp'
        >
          <FontAwesomeIcon className='fa-3x mx-1' icon={faWhatsappSquare} />
        </a>
        {/* <a
          href='https://wa.me/+528135514315?text=Necesito%20información%20de%20productos%20Amerex'
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Solicitar información por WhatsApp'
        >
          <FontAwesomeIcon className='fa-3x mx-1' icon={faWhatsappSquare} />
        </a> */}
        {/* <Link to="/">
          <FontAwesomeIcon className="fa-3x mx-1" icon={faTwitterSquare} />
        </Link>
        <Link to="/">
          <FontAwesomeIcon className="fa-3x mx-1" icon={faInstagramSquare} />
        </Link> */}

        <p>Amerex México&copy;2022</p>
      </div>
    </footer>
  )
}

export default Footer
